export default __webpack_public_path__ + "static/media/ma.9758b027.svg";